module.exports = __webpack_public_path__ + "img/Chemistry.9d68fa90.jpg";